import Controls from "../components/Controls";
import { useTranslation } from "../components/Localization";
import RoomHeader from "../components/RoomHeader";

export default function SalonScorePage() {
  const { t } = useTranslation();
  return <main className="screen score salon-score">
    <RoomHeader roomId="salon" />
    <div className="score-copy"><strong>{t("common.completed")}</strong><div>{Array.from({ length: 4 }, (_, index) => <i key={index} />)}</div><span>4/4</span></div>
    <Controls backTo="/szalon/video" nextTo="/petkiek" />
  </main>;
}
